import React, { Dispatch, FC, useCallback } from 'react';
import { AchCloverPaymentInput } from './AchCloverPaymentInput';

import styles from './styles.module.scss';

export type PaymentInfoErrors = {
  errors: Record<Clover.InputFieldType, string | undefined>;
  isAllTouched: boolean;
};

type PaymentInfoProps = {
  cloverElementsInstance: Clover.ElementRoot;
  toggleButtonDisableState: Dispatch<boolean>;
};

// component starts here
const AchPaymentInfo: FC<PaymentInfoProps> = props => {
  const { cloverElementsInstance, toggleButtonDisableState } = props;

  const handleValidationChange = useCallback((formState) => {
    formState?.ACH_ELEMENTS && toggleButtonDisableState(formState.ACH_ELEMENTS?.isFormValid);
  }, [toggleButtonDisableState]);

  return (
    <div className={styles.wrapper}>
      <AchCloverPaymentInput
        cloverElementsInstance={cloverElementsInstance}
        fieldName="ACH_ELEMENTS"
        onValidationBlur={handleValidationChange}
        onValidationChange={handleValidationChange}
      />
    </div>
  );
};

export { AchPaymentInfo };
